import React, { useState } from "react";
import styles from "./styles/Newsletter.module.css"
import mailImg from "./styles/img/mail.svg"
import { useEffect } from "react";
import { submitCaptcha } from "../../../Utils/captcha";
import Loading from "../../Loading/Loading";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
const base_url = config.base_url
function Newsletter() {
    const [auth, setAuth] = useState()
    const [enabledButton, setEnableButton] = useState(true)
    const [message, setMessage] = useState()
    const [subscribed, setSubscribed] = useState(true)
    const [unsubscribed, setUnsubscribed] = useState(false)
    const urlParams = new URLSearchParams(window.location.search)
    const [modal, setModal] = useState(<Loading text={"Loading"}/>)
    const jwttoken = urlParams.get('token');
    const navigate = useNavigate()
    useEffect(()=>{
        submitCaptcha()
        .then(token=>{
            return fetch(base_url+"/token/unsubscribe/permissions", {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-type': 'application/x-www-form-urlencoded',
                    'credentials':'include'
                },
                body: `token=${token}&jwttoken=${jwttoken}`,
                credentials:'include'
            })
        })
        .then(res=>{
            setModal()
            if (res.status===200) return res.json()
            else throw new Error()
        })
        .then(data=>{
            // {subscribed:false, email:auth.username}
            setAuth({email:data?.email})
            data.subscribed?setSubscribed(true):setSubscribed(false)
        })
        .catch(e=>{
            setModal(<Loading text={"An error occurred"}/>)
            setTimeout(()=>{
                navigate('/login')
            }, 2000)
        })

    }, [])
    const handleUnsbscribed=() =>{
        setEnableButton(false)
        fetch(base_url+"/token/unsubscribe/confirm", {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-type': 'application/x-www-form-urlencoded',
                'credentials':'include'
            },
            credentials:'include'
        })
        .then(res=>{
            
            if(res.status===200) {setSubscribed(false);setUnsubscribed(true)}
            else{
                setEnableButton(true)
                setMessage('An error occurred')
                setTimeout(()=>{
                    setMessage()
                }, 3000)
            }
        })
        .catch(e=>{
            console.log(e)
        })
    }
    return (
        
        <div className={styles.main}>
           { modal?modal:
           <>
            <div className={styles.title}>Unsubscribe From Our Newsletter</div>
            <img src={mailImg} alt="Email" />

            <div className={styles.box}>
                <div className={styles.subtitle}>
                    <div>
                        {auth?.email}
                    </div>
                    {unsubscribed &&
                        <strong>
                            We have successfully removed you from our newsletter.
                        </strong>
                    }
                    {subscribed
                        ?
                        (
                            <strong>
                                Are you sure you want to unsubscribe OSTREON Newsletter?
                            </strong>
                        )
                        :
                        (
                            <strong>
                                You are not subscribed to our newsletter.
                            </strong>
                        )
                    }
                </div>
                {subscribed &&
                    (
                        <>
                            <div>
                                Our newsletter are not periodically, and are serving to provide you <strong>useful tips, promotions, and valuable information</strong> directly to your email address.
                                You can unsubscribe at any moment.
                            </div>
                            <button disabled={!enabledButton} onClick={()=>handleUnsbscribed()} className={styles.unsubscribe}>
                                Unsubscribe
                            </button>
                            {message&&<div>{message}</div>}
                        </>

                    )}

                <div className={styles.rect}></div>

                <div>
                    <strong>
                        Please Note:
                    </strong><br></br>
                    Unsubscribing from the newsletter will not stop keep alive notifications or other email related to your subscription plan.<br></br>
                    If you wish to stop receiving essential inheritance alerts, go to “My Account” and select “Deactivate my Digital Inheritance”
                </div>
            </div>
            </>}
        </div>
    )

}
export { Newsletter };